document.addEventListener("DOMContentLoaded", () => {
  const doctorReviews = document.querySelectorAll(".reviews-doctor-slider");

  doctorReviews.forEach(reviews => {
    const slider = new Splide( reviews, {
      type: 'slide',
      rewind: true,
      pagination: true,
      arrows: false,
      perPage: 4,
      gap: 26,
      breakpoints: { 1024: { perPage: 2, gap: 16, padding: { right: '5rem' } }, 750: { perPage: 1, gap: 32, padding: { right: '4rem' } } }
    });

    slider.mount();
  });
});